// extracted by mini-css-extract-plugin
module.exports = {"cookiesTable":"CookiesTable_cookiesTable__MUYrU","cookiesSdk":"CookiesTable_cookiesSdk__jd5D0"};